/**
 * This enum is used for getting userprofilefields.
 */
export enum UserProfileFieldsEnum {
  EMAIL = 'email',
  NAME = 'name',
  CLIENT_ID = 'clientID',
  HG_CUSTOMER = 'hg-customer',
}
